import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {userInfo as userInfoAction} from 'actions'
import useUserLoginStatus from './useUserLoginStatus'

function useUserInfoProvider () {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const fetchData = useCallback(async () => {
    if (!isLogin) return
    const res = await ApiSdk.common.getBaseDetail()
    dispatch(userInfoAction(res))
  }, [dispatch, isLogin])

  useEffect(() => {
    if (!isLogin) return
    fetchData()
  }, [dispatch, fetchData, isLogin])
}

export default useUserInfoProvider
